import React from 'react'

export default function FaceFeature({ scaleX, spacing, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} style={{ opacity: 0.2 }}>
      <g transform={`translate(${-spacing})`}>
        <path
          d="M1.00977 5.51318C1.50977 4.67318 2.30972 4.0932 3.14972 3.6632C4.00972 3.2532 4.94974 3.00313 5.91974 3.09313C5.08974 3.58313 4.27974 3.93313 3.47974 4.34313C2.66974 4.73313 1.88977 5.13318 1.00977 5.51318Z"
          fill={outline}
        />
        <path
          d="M0.239746 1.77316C1.15975 1.13316 2.24972 0.833094 3.33972 0.703094C4.42972 0.603094 5.60976 0.733099 6.56976 1.3331C5.45976 1.3131 4.44973 1.35309 3.40973 1.45309C2.37973 1.54309 1.34975 1.70316 0.239746 1.77316Z"
          fill={outline}
        />
      </g>
      <g transform={`translate(${spacing})`}>
        <path
          d="M58.4398 5.51318C57.5598 5.13318 56.7798 4.72312 55.9698 4.33312C55.1698 3.93312 54.3598 3.57312 53.5298 3.08312C54.4998 2.99312 55.4498 3.24319 56.2998 3.65319C57.1398 4.09319 57.9398 4.68318 58.4398 5.51318Z"
          fill={outline}
        />
        <path
          d="M59.2096 1.77317C58.0996 1.70317 57.0696 1.5431 56.0296 1.4531C54.9896 1.3531 53.9796 1.3131 52.8696 1.3331C53.8196 0.733102 54.9996 0.613097 56.0996 0.703097C57.1996 0.833097 58.2796 1.14317 59.2096 1.77317Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
